
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import { get, pick } from 'lodash';
import { connect } from 'react-redux';

// class name
// import cx from 'classnames';

// import static dropdown data
import hoursPerWeekList from '../../../../../../common/staticData/hoursPerWeekList';
import hoursPerDayList from '../../../../../../common/staticData/hoursPerDayList';

// components
import DropDownMenu from '../../../../../../common/components/c_DropDownMenu';
import CheckList from '../../../../../../common/components/c_CheckList';
import ProgressComponent from '../../../../../../common/components/C_ProgressComponent';
import ToggleButton from '../../../../../../common/components/c_ToggleButton';
import TextArea from '../../../../../../common/components/c_TextArea';
import DateInput from '../../../../../../common/components/DateInput';

const yesNo = [{value: true, primaryText: 'Yes', subElement: 'localJobDetails'}, {value: false, primaryText: 'No', subElement: null}];

const dropDownCustomization = {
  labelStyle: {
    padding: 0,
    margin: 0,
    maxWidth: '90%'
  },
  underlineStyle: {
    marginLeft: 0
  },
  containerStyle: {
    margin: '30px 0 10px 45px'
  },
  floatingLabelStyle: {
    left: 0,
  }
};

@connect(store => {
  return {
    labels: get(store, 'labels.AvailabilityInformation', {})
  };
}, undefined, undefined, { withRef: true })
export default class AvailabilityInformation extends ProgressComponent {
  static propTypes = {
    adminView: PropTypes.bool.isRequired,
    profile: PropTypes.object.isRequired,
    model: PropTypes.string.isRequired,
    staticData: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    errorUpdate: PropTypes.func.isRequired,
    script: PropTypes.bool
  }

  static defaultProps = {
    profile: {}
  }

  constructor(props) {
    super(props);
    this.handleDatePickerUI = ::this.handleDatePickerUI;
    this.handleDropDownMenuUI = ::this.handleDropDownMenuUI;
    this.handleDropDownMenuStaticUI = ::this.handleDropDownMenuStaticUI;

    this.state = {
      validation: Object.assign({}, pick(props.validation, ['availabilityHoursPerDay', 'availabilityHoursPerWeek', 'workDays', 'availabilityDate']))
    };
  }

  handleDatePickerUI(prop, label) {
    return {
      'data-id': prop,
      defaultValue: this.props.profile[prop],
      separatedFloatingText: label,
      isDirty: get(this.state, `validation.${prop}.errors[0]`) ? true : false,
      errorText: get(this.state, `validation.${prop}.errors[0]`),
      onErrorChange: this.props.errorUpdate,
      onBlur: this.validateUpdate(this.props.model, prop, this.updateTempState)
    };
  }

  handleDropDownMenuUI(prop, staticDataProp, label) {
    return {
      'data-id': prop,
      key: `${prop}_${this.props.profile[prop]}`,
      defaultValue: this.props.profile[prop],
      menuItems: this.props.staticData[staticDataProp],
      floatingLabelText: label,
      errorText: get(this.state, `validation.${prop}.errors[0]`),
      onChange: this.validateUpdate(this.props.model, prop, this.updateTempState)
    };
  }

  handleDropDownMenuStaticUI(prop, staticData, label) {
    return {
      'data-id': prop,
      key: `${prop}_${this.props.profile[prop]}`,
      defaultValue: this.props.profile[prop],
      menuItems: staticData,
      floatingLabelText: label,
      errorText: get(this.state, `validation.${prop}.errors[0]`),
      onChange: this.validateUpdate(this.props.model, prop, this.updateTempState)
    };
  }

  toggleButtonProperties(prop, staticData, label) {
    return {
      'data-id': prop,
      key: `${prop}_${this.props.profile[prop]}`,
      defaultValue: this.props.profile[prop],
      menuItems: yesNo,
      floatingLabelText: label,
      validation: this.props.validation[prop],
      onErrorChange: this.props.errorUpdate,
      onChange: this.updateTempState.bind(this, this.props.model, prop)
    };
  }

  textFieldProperties(prop, label) {
    return {
      'data-id': prop,
      key: `${prop}_${this.props.profile[prop]}`,
      defaultValue: this.props.profile[prop],
      value: get(this.props, `tempState.profile.${prop}]`, null),
      floatingLabelText: label,
      validation: this.props.validation[prop],
      onBlur: this.updateTempState.bind(this, this.props.model, prop)
    };
  }

  textAreaProperties(prop, label) {
    return {
      'data-id': prop,
      key: `${prop}_${this.props.profile[prop]}`,
      defaultValue: this.props.profile[prop],
      validation: this.props.validation[prop],
      onErrorChange: this.props.errorUpdate,
      onBlur: this.updateTempState.bind(this, this.props.model, prop)
    };
  }

  dateDifference(availability) {
    const startDate = new Date(availability);
    const now = (new Date());
    return (startDate.getFullYear() - now.getFullYear()) * 12 +
      (startDate.getMonth() - now.getMonth());
  }

  genFakeDropdown(str) {
    return {
      value: str,
      menuItems: [str],
      disabled: true
    };
  }

  render() {
    const localJob = get(this.props.tempState, 'profile.localJob', this.props.profile.localJob);
    // Employed or Phasing into Retirement.
    const employed = this.props.profile.employmentStatus.id === 1 || this.props.profile.employmentStatus.id === 4;
    return (
      <div className='application-section-container expanded-accordion-content availability-information clearfix'>
        <div className='form-heading'>
          Availability Information
        </div>

        {
          this.props.script && this.props.adminView
          &&
          <div>
            <div className='speaking-callout'>
              {this.props.labels.speakingCallout}
            </div>
          </div>
        }

        <div className='availability-info-form-contents'>
          <div className='box'>
            <DateInput
              data-id={'availability-date-icon'}
              autoOk
              dataId={'availability Date'}
              minDate={new Date()}
              {...this.textFieldProperties('availabilityDate', 'Availability Date')}
            />
          </div>
          {
            this.props.adminView
            &&
            <div className='box'>
              <DropDownMenu floatingLabelText='Employment status'
                data-id='employement status'
                {...this.genFakeDropdown(this.props.profile.employmentStatus.name)}
                {...dropDownCustomization}/>
            </div>
          }
          {
            this.props.script && this.props.adminView &&
            ((this.dateDifference(get(this.props.tempState, 'profile.availabilityDate', 0)) > 4) || (this.dateDifference(this.props.profile.availabilityDate) > 4))
            &&
            <div>
              <ul className='instructions-list'>
                <li>It is too soon for the interview.</li>
                <li>When your availability is within 4 month, I will contact you to update your application and will call you to complete the application interview.</li>
              </ul>
              <div className='speaking-callout'>
                Change the Status to “Applicant in Waiting.”
              </div>
            </div>
          }
          <div className='box'>
            <DropDownMenu
              {...this.handleDropDownMenuStaticUI('availabilityHoursPerWeek', hoursPerWeekList, 'How many hours per week would you prefer to work?')}
            />
          </div>
          <div className='box'>
            <DropDownMenu
              {...this.handleDropDownMenuStaticUI('availabilityHoursPerDay', hoursPerDayList, 'How many hours per day?')}
            />
          </div>
          <div className='box'>
            <CheckList
              canAutoPosition='true'
              {...this.handleDropDownMenuUI('workDays', 'dayAvailableTypes', 'Days of the week?')}
            />
          </div>
          {
            this.props.adminView
            &&
            <ToggleButton
              className='local-job'
              {...this.toggleButtonProperties('localJob', yesNo, 'Are you also looking for a job locally?')}
            >
            {{
              localJobDetails: <TextArea
                 description='If yes, explain:'
                 {...this.textAreaProperties('localJobDetails', 'If yes, explain:')}
              />
            }}
            </ToggleButton>
          }

          {
            (this.props.script && this.props.adminView && !!employed)
            &&
            <div className='speaking-callout'>
              {`Since you are still working, we want you to understand we cannot take responsibility if you leave your current job or guarantee that we can place you quickly with one of our clients. If we do find a placement for you, you must agree to give two weeks' notice.`}
            </div>
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Preferences/c_AvailabilityInformation/index.js